import { SET_SETTING } from './../mutation-types';
import settingService from '../../services/setting';

export default {
  namespaced: true,
  state: {
    authorization: null,
  },
  mutations: {
    [SET_SETTING](state, authorization) {
      state.authorization = authorization;
    },
  },
  actions: {
    checkOrSet({ commit, state }) {
      return new Promise((resolve) => {
        if (state.authorization) {
          resolve(state.authorization);
        } else {
          settingService.fetch().then((data) => {
            commit(SET_SETTING, data);
            resolve(data);
          });
        }
      });
    },
  },
  getters: {},
};
